import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sliderblock",
  "use": "icon-sliderblock-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\" \" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sliderblock\">\n<g id=\"icon-sliderblock_&#230;&#187;&#145;&#229;&#157;&#151;-01 1\">\n<path id=\"icon-sliderblock_Vector 5\" d=\"M0.5 8H15.5\" stroke=\"#606B83\" stroke-linecap=\"round\" />\n<circle id=\"icon-sliderblock_Ellipse 62\" cx=\"6\" cy=\"8\" r=\"2.5\" fill=\"white\" stroke=\"#606B83\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol